import React from "react";
import CIcon from "@coreui/icons-react";
import { cilBalanceScale, cilBug, cilCasino, cilLibrary, cilFolder, cilSettings } from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react-pro";

const _nav = [
  // Kurum (Organisation) Section
  {
    component: CNavGroup,
    name: "Kurum",
    index: "0",
    icon: (
      <CIcon
        icon={cilBalanceScale}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "organisation",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "0.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "organisation",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Başvurular",
            to: "/application-list",
            index: "0.1.1",
            role: "organisation",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Öz D. Raporu",
            to: "/self-report",
            index: "0.1.2",
            role: "organisation",
            show: "true",
          },
          {
            component: CNavItem,
            name: "30 Gün Yanıtı",
            to: "/month-response",
            index: "0.1.3",
            role: "organisation",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "0.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "organisation",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "ÖDR Değerlendirme Çizelgesi",
            to: "/appeal-template",
            index: "0.2.1",
            role: "organisation",
            show: "true",
          },
        ]
      },
    ]
  },

  // Takım Başkanı (Team Leader) Section
  {
    component: CNavGroup,
    name: "Takım Başkanı",
    index: "1",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "teamLeader",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "1.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "teamLeader",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Şekilsel İnceleme",
            to: "/formal-review",
            index: "1.1.1",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Değerlendirme Çizelgesi",
            to: "/self-report-preview",
            index: "1.1.2",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Taslak Rapor",
            to: "/draft-report",
            index: "1.1.3",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Ölçütler İçin Karar Tabloları",
            to: "/final-report",
            index: "1.1.4",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Tutarlılık Kesin Raporu",
            to: "/consistency-final-report",
            index: "1.1.5",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "SAK'tan Geri Dönen Programlar",
            to: "/application-loop",
            index: "1.1.6",
            role: "teamLeader",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "1.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "teamLeader",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bireysel Değerlendirme Çizelgesi",
            to: "/personal-appeal-template",
            index: "1.2.2",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Takım Başkanı Değerlendirme Çizelgesi",
            to: "/team-leader-appeal-template",
            index: "1.2.3",
            role: "teamLeader",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Ölçütler İçin Karar Tabloları",
            to: "/team-appeal-template-for-final-report",
            index: "1.2.4",
            role: "teamLeader",
            show: "true",
          },
        ]
      },
    ]
  },

  // Değerlendirici (Evaluator) Section
  {
    component: CNavGroup,
    name: "Değerlendirici",
    index: "2",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "evaluator",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "2.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "evaluator",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Değerlendirme Çizelgesi",
            to: "/self-report-preview",
            index: "2.1.1",
            role: "evaluator",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Program 30 Gün Yanıtı Ve Kararları",
            to: "/final-report",
            index: "2.1.2",
            role: "evaluator",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "2.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "evaluator",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bireysel Değerlendirme Çizelgesi",
            to: "/personal-appeal-template",
            index: "2.2.2",
            role: "evaluator",
            show: "true",
          },
        ]
      },
    ]
  },

  // Öğrenci (Student) Section
  {
    component: CNavGroup,
    name: "Öğrenci",
    index: "3",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "student",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "3.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "student",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Değerlendirme Çizelgesi",
            to: "/self-report-preview",
            index: "3.1.1",
            role: "student",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Program 30 Gün Yanıtı Ve Kararları",
            to: "/final-report",
            index: "3.1.2",
            role: "student",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "3.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "student",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bireysel Değerlendirme Çizelgesi",
            to: "/personal-appeal-template",
            index: "3.2.1",
            role: "student",
            show: "true",
          },
        ]
      },
    ]
  },

  // Gözlemci (Watcher) Section
  {
    component: CNavGroup,
    name: "Gözlemci",
    index: "4",
    icon: (
      <CIcon
        icon={cilLibrary}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "watcher",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "4.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "watcher",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Değerlendirme Çizelgesi",
            to: "/self-report-preview",
            index: "4.1.1",
            role: "watcher",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Program 30 Gün Yanıtı Ve Kararları",
            to: "/final-report",
            index: "4.1.2",
            role: "watcher",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "4.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "watcher",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bireysel Değerlendirme Çizelgesi",
            to: "/personal-appeal-template",
            index: "4.2.1",
            role: "watcher",
            show: "true",
          },
        ]
      },
    ]
  },

  // TKK (Consistency) Section
  {
    component: CNavGroup,
    name: "TKK",
    index: "5",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "consistency",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "5.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "consistency",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Program Raporları",
            to: "/consistency",
            index: "5.1.1",
            role: "consistency",
            show: "true",
          },
        ]
      },
    ]
  },

  // Editor Section
  {
    component: CNavGroup,
    name: "Editor",
    index: "6",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "editor",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "6.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "editor",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bekleyen Kesin Raporlar",
            to: "/editor",
            index: "6.1.1",
            role: "editor",
            show: "true",
          },
        ]
      },
    ]
  },

  // YKK (Spelling) Section
  {
    component: CNavGroup,
    name: "YKK",
    index: "7",
    icon: (
      <CIcon
        icon={cilCasino}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "spelling",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "7.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "spelling",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Yazım Kontrol",
            to: "/spelling-control",
            index: "7.1.1",
            role: "spelling",
            show: "true",
          },
        ]
      },
    ]
  },

  // Admin Section - Shows all items organized in subfolders
  {
    component: CNavGroup,
    name: "Admin",
    index: "8",
    icon: (
      <CIcon
        icon={cilBalanceScale}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
    role: "admin",
    show: "true",
    items: [
      {
        component: CNavGroup,
        name: "İşlemler",
        index: "8.1",
        icon: (
          <CIcon
            icon={cilSettings}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "admin",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Başvurular",
            to: "/application-list",
            index: "8.1.1",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Öz D. Raporu",
            to: "/self-report",
            index: "8.1.2",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "30 Gün Yanıtı",
            to: "/month-response",
            index: "8.1.3",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "SAK'tan Geri Dönen Programlar",
            to: "/application-loop",
            index: "8.1.4",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Değerlendirme Çizelgesi",
            to: "/self-report-preview",
            index: "8.1.5",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Taslak Rapor",
            to: "/draft-report",
            index: "8.1.6",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Tutarlılık Kesin Raporu",
            to: "/consistency-final-report",
            index: "8.1.7",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Kesin Rapor",
            to: "/final-report",
            index: "8.1.8",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Değerlendirme",
            to: "/evaluation",
            index: "8.1.9",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Kesin Rapor",
            to: "/draft-report",
            index: "8.1.11",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Program Raporları",
            to: "/consistency",
            index: "8.1.12",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Yazım Kontrol",
            to: "/spelling-control",
            index: "8.1.14",
            role: "admin",
            show: "true",
          },
        ]
      },
      {
        component: CNavGroup,
        name: "Belgeler",
        index: "8.2",
        icon: (
          <CIcon
            icon={cilFolder}
            style={{ width: 20, height: 20 }}
            customClassName="nav-icon"
          />
        ),
        role: "admin",
        show: "true",
        items: [
          {
            component: CNavItem,
            name: "Bireysel Değerlendirme Çizelgesi",
            to: "/personal-appeal-template",
            index: "8.2.1",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Takım Başkanı Değerlendirme Çizelgesi",
            to: "/team-leader-appeal-template",
            index: "8.2.2",
            role: "admin",
            show: "true",
          },
          {
            component: CNavItem,
            name: "Ölçütler için Karar Tabloları",
            to: "/team-appeal-template-for-final-report",
            index: "8.2.3",
            role: "admin",
            show: "true",
          },
        ]
      },
    ]
  },

  {
    component: CNavTitle,
    name: "Yardım",
    index: "9",
    show: "true",
  },
  {
    component: CNavItem,
    name: "Denemeler",
    to: "/try",
    index: "10",
    icon: (
      <CIcon
        icon={cilBug}
        style={{ width: 25, height: 25 }}
        customClassName="nav-icon"
      />
    ),
  },
];

export default _nav;
